import React, {useEffect, useState} from 'react';
import {getAlbum} from '../../libraries/DnaApi';

const FALLBACK_COVER = '/images/cover-placeholder.jpg';

/** Album page: cover, credit, and the tracks we've analyzed in order. */
export default function AlbumView({albumId, onPlay, onArtist, onBack}) {
    const [data, setData] = useState(null);

    useEffect(() => {
        setData(null);
        let active = true;
        getAlbum(albumId).then((d) => active && setData(d || {missing: true}))
            .catch(() => active && setData({missing: true}));
        return () => {
            active = false;
        };
    }, [albumId]);

    return (
        <div className="mx-auto w-full max-w-[900px]">
            <button type="button" onClick={onBack}
                    className="mb-5 flex items-center gap-2 text-[13px] font-semibold text-white/50 transition hover:text-white">
                <i className="fa-solid fa-arrow-left text-[11px]"/> Back
            </button>
            {data === null && <p className="mt-4 text-sm text-white/40">Loading…</p>}
            {data?.missing && <p className="mt-4 text-sm text-white/40">This album isn't in the catalog.</p>}

            {data && !data.missing && (
                <>
                    <div className="flex flex-col items-center gap-6 sm:flex-row sm:items-end sm:gap-8">
                        <img src={data.cover || FALLBACK_COVER} alt=""
                             className="h-[180px] w-[180px] flex-none rounded-2xl object-cover shadow-[0_30px_70px_rgba(0,0,0,0.55)]"/>
                        <div className="text-center sm:text-left">
                            <h1 className="font-heading text-[26px] font-bold tracking-[-0.015em] sm:text-[32px]">{data.album}</h1>
                            <button type="button" onClick={() => onArtist(data.artist)}
                                    className="mt-1 text-[15px] text-white/60 transition hover:text-white hover:underline">
                                {data.artist}
                            </button>
                            <div className="mt-1 text-[12px] text-white/40">
                                {[data.year, data.songs.length + ' songs in the catalog'].filter(Boolean).join(' · ')}
                            </div>
                        </div>
                    </div>

                    <div className="mt-8">
                        {data.songs.map((s) => (
                            <button key={s.id} type="button" onClick={() => onPlay(s, data.songs)}
                                    className="flex w-full items-center gap-4 rounded-xl p-2.5 text-left transition hover:bg-white/[0.07]">
                                <span className="w-6 flex-none text-right text-[12px] tabular-nums text-white/[0.35]">
                                    {s.track_no || '·'}
                                </span>
                                <span className="min-w-0 flex-1">
                                    <span className="flex items-center gap-2 truncate text-[13.5px] font-semibold">
                                        {s.title}
                                        {s.is_live && <span className="flex-none rounded-full bg-apple-red/15 px-1.5 py-0.5 text-[8.5px] font-extrabold uppercase text-apple-red">Live</span>}
                                        {s.is_remix && <span className="flex-none rounded-full bg-white/10 px-1.5 py-0.5 text-[8.5px] font-extrabold uppercase text-white/60">Remix</span>}
                                    </span>
                                </span>
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
